import {textField} from "material-components-web";

export class FieldHandler{
    public static setFieldWarning = (id: string, msg:string): void => {
        let fieldGroup = document.getElementById(id+'Group');
        if(fieldGroup){
            fieldGroup.classList.add('has-warning');
        } else {
            console.error("Cannot find field "+id+"Group");
        }

        let fbEl = document.getElementById(id+"Feedback");
        if (fbEl) {
            fbEl.classList.add('dv', 'dv-warning');
        } else {
            console.error("Cannot find field "+id+"Feedback");
        }

        let helpEl = document.getElementById(id+"Help");
        if(helpEl) {
            helpEl.innerText = msg;

        } else {
            console.error("Cannot find field "+id+"Help");
        }
    };

    public static setFieldError = (id: string, msg: string):void => {
        let fieldEl = document.getElementById(id+"Group");
        if (fieldEl) {
            fieldEl.classList.add('has-error');
        } else {
            console.error("Cannot find field "+id+"Group");
        }

        let fbEl = document.getElementById(id+"Feedback");
        if (fbEl) {
            fbEl.classList.add('dv', 'dv-error');
        } else {
            console.error("Cannot find field "+id+"Feedback");
        }

        let helpEl = document.getElementById(id+"Help");
        if(helpEl) {
            helpEl.innerText = msg;
        } else {
            console.error("Cannot find field "+id+"Help");
        }
    };

    public static clearFieldError = (id:string) => {
        let fieldEl = document.getElementById(id+"Group");
        if(fieldEl) {
            fieldEl.classList.remove("has-error");
            fieldEl.classList.remove('has-warning');
        } else {
            console.debug("Cannot find field "+id+"Group");
        }

        let fbEl = document.getElementById(id+"Feedback");
        if(fbEl) {
            fbEl.classList.remove("dv", "dv-error");
            fbEl.classList.remove("dv", "dv-warning");
        } else {
            console.debug("Cannot find field "+id+"Feedback");
        }

        let helpEl = document.getElementById(id + "Help");
        if(helpEl) {
            helpEl.innerText = "";
        } else {
            console.debug("Cannot find field "+id+"Help");
        }
    };

    public static getFieldValue = (id:string) => {
        let input = <HTMLInputElement>document.getElementById(id);
        if (input !== null && input !== undefined) {
            return input.value;
        }
        return "";
    };

    public static setFieldValue = (id:string, val:string, isMaterial: boolean = false):void => {
        const input = <HTMLInputElement | HTMLTextAreaElement>document.getElementById(id);
        if (input) {
            if (isMaterial){
                textField.MDCTextField.attachTo(input.parentElement).value = val;
                return
            }
            input.value = val;
        } else {
            console.debug('Field +'+id+' not found');
        }
    };

    public static getValueFromSpan = (id:string):string => {
        let span = document.getElementById(id);
        if(span){
            return span.innerText.trim();
        }
        console.warn('cannot get element "'+id+'"');
        return "";
    };

    public static setValueToSpan = (id:string, val:string):void => {
        (<HTMLSpanElement>document.getElementById(id)).innerText = val;
    };

    public static setValueToHeader = (id:string, val: string):void => {
        (<HTMLHeadingElement>document.getElementById(id)).innerText = val;
    };

    public static getHrefFromAnchor = (id:string): string => {
        let a = document.getElementById(id);
        if(a){
            let element = <HTMLAnchorElement>a;
            return element.href;
        }
        console.warn('cannot get anchor "'+id+'"');
        return "";
    };
    public static setEmailAnchorValue = (id:string, val: string): void => {
        let element = document.getElementById(id);
        if(element){
            let anchor = <HTMLAnchorElement>element;
            anchor.href = "mailto:"+val;
            anchor.innerHTML = '<i class="dv dv-message"></i>&nbsp;'+val;
        }
    };

    public static setLogoValue = (id:string, val:string): void => {
        let logo = <HTMLDivElement>document.getElementById(id);
        if(val.startsWith('dv-')) {
            logo.innerHTML = '<i class="dv ' + val + '"></i>';
        } else if (val.startsWith('http://') || val.startsWith('https://')){
            logo.innerHTML = '<img src="'+val+'" width="43" height="43">'
        } else {
            console.info('no organization logo found or wrong url format');
            logo.innerHTML = '<i class="dv dv-globe"></i>';
        }
    };

    public static getBooleanValue = (id: string):boolean => {
        let element = <HTMLInputElement>document.getElementById(id);
        if (element) {
            return element.checked;
        } else {
            console.error("Cannot find field "+id);
            return undefined;
        }
    };

    public static getMultipleValue = (id: string, seperator: string): string[] => {
        let val = FieldHandler.getFieldValue(id);
        let split: string[] = val.split(seperator);
        if (split.length < 1){
            return Array<string>();
        }
        let retVal = Array<string>();
        for (let i = 0; i < split.length; i++){
            let s = split[i];
            if(s.isNullOrEmpty()){
                continue;
            }
            retVal.push(s.replace(/\s/g, ''))
        }
        return retVal;
    };
    public static setMultipleValue = (id: string, seperator: string, val:string[]):void => {
        (<HTMLInputElement>document.getElementById(id)).value = val.join(seperator);
    };

    public static getSelectedText = (id:string):string => {
        let input = <HTMLSelectElement>document.getElementById(id);
        if(input !== null && input !== undefined) {
            return input.selectedOptions[0].text;
        }
        return undefined;
    };
}